import * as React from "react";

import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";

import Header from "./Header";
import Footer from "./Footer";

import theme from "../../theme";
import "./global.css";
// src/global.css
const Layout = (props) => {
  return (
    <ThemeProvider theme={theme}>
      <Box style={{ overflowX: "hidden" }}>
        <Header />
        {props.children}
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
